import { useDebouncedEffect } from '@react-hookz/web';
import { type FC, useEffect, useState } from 'react';

import TextInput from 'molecules/TextInput';

import useGuidesListingStore, { setGuidesSearch } from 'layout/Listing/variants/guides/store';

const SearchBar: FC<{ placeholder?: string }> = ({ placeholder }) => {
  const searchStore = useGuidesListingStore(state => state.search);
  const [search, setSearch] = useState('');

  useDebouncedEffect(() => setGuidesSearch(search), [search], 500);

  useEffect(() => {
    setSearch(searchStore);
  }, [searchStore]);

  return (
    <div className="w-full justify-self-end sm:max-w-[360px] lg:col-start-2 lg:row-start-1">
      <TextInput placeholder={placeholder} endIcon="search" onChange={e => setSearch(e.target.value)} value={search} />
    </div>
  );
};

export default SearchBar;
